import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { DishServices } from '../../services';
import { Globals } from '../../../../globals';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DishPreparationPage } from '../dish-cost/dish-preparation/dish-preparation';

/**
 * Generated class for the DishCreateNutritionPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-dish-create-nutrition',
    templateUrl: 'dish-create-nutrition.html',
})
export class DishCreateNutritionPage {

    public form: FormGroup;
    update_state: boolean = false;
    dish_uid: any;
    dish_name: string;
    dish: any;


    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public dishServices: DishServices,
        public globals: Globals,
        public fb: FormBuilder,
        public translate: TranslateService) {

        this.update_state = this.navParams.get('update');
        this.dish_uid = this.navParams.get('dish_uid');
        this.dish_name = this.navParams.get('dish_name');
        this.dish = this.navParams.get('dish');

        if (this.update_state) {
            this.form = fb.group({
                nutrition_100_energy: [this.dish.nutrition_100_energy],
                nutrition_100_fat: [this.dish.nutrition_100_fat],
                nutrition_100_saturate: [this.dish.nutrition_100_saturate],
                nutrition_100_carbohydrate: [this.dish.nutrition_100_carbohydrate],
                nutrition_100_sugar: [this.dish.nutrition_100_sugar],
                nutrition_100_fiber: [this.dish.nutrition_100_fiber],
                nutrition_100_protein: [this.dish.nutrition_100_protein],
                nutrition_100_salt: [this.dish.nutrition_100_salt],
                nutrition_portion_energy: [this.dish.nutrition_portion_energy],
                nutrition_portion_fat: [this.dish.nutrition_portion_fat],
                nutrition_portion_saturate: [this.dish.nutrition_portion_saturate],
                nutrition_portion_carbohydrate: [this.dish.nutrition_portion_carbohydrate],
                nutrition_portion_sugar: [this.dish.nutrition_portion_sugar],
                nutrition_portion_fiber: [this.dish.nutrition_portion_fiber],
                nutrition_portion_protein: [this.dish.nutrition_portion_protein],
                nutrition_portion_salt: [this.dish.nutrition_portion_salt],
                traces: [this.dish.traces],
            });
        } else {
            this.form = fb.group({
                nutrition_100_energy: [''],
                nutrition_100_fat: [''],
                nutrition_100_saturate: [''],
                nutrition_100_carbohydrate: [''],
                nutrition_100_sugar: [''],
                nutrition_100_fiber: [''],
                nutrition_100_protein: [''],
                nutrition_100_salt: [''],
                nutrition_portion_energy: [''],
                nutrition_portion_fat: [''],
                nutrition_portion_saturate: [''],
                nutrition_portion_carbohydrate: [''],
                nutrition_portion_sugar: [''],
                nutrition_portion_fiber: [''],
                nutrition_portion_protein: [''],
                nutrition_portion_salt: [''],
                traces: [''],
            });
        }
    }

    submit() {
        if (!this.update_state) {
            this.update();
        } else {
            this.update();
        }
    }



    update() {
        this.dishServices.afs.collection('dish').doc(this.dish_uid).update({
            'nutrition_100_energy': this.form.value.nutrition_100_energy,
            'nutrition_100_fat': this.form.value.nutrition_100_fat,
            'nutrition_100_saturate': this.form.value.nutrition_100_saturate,
            'nutrition_100_carbohydrate': this.form.value.nutrition_100_carbohydrate,
            'nutrition_100_sugar': this.form.value.nutrition_100_sugar,
            'nutrition_100_fiber': this.form.value.nutrition_100_fiber,
            'nutrition_100_protein': this.form.value.nutrition_100_protein,
            'nutrition_100_salt': this.form.value.nutrition_100_salt,
            'nutrition_portion_energy': this.form.value.nutrition_portion_energy,
            'nutrition_portion_fat': this.form.value.nutrition_portion_fat,
            'nutrition_portion_saturate': this.form.value.nutrition_portion_saturate,
            'nutrition_portion_carbohydrate': this.form.value.nutrition_portion_carbohydrate,
            'nutrition_portion_sugar': this.form.value.nutrition_portion_sugar,
            'nutrition_portion_fiber': this.form.value.nutrition_portion_fiber,
            'nutrition_portion_protein': this.form.value.nutrition_portion_protein,
            'nutrition_portion_salt': this.form.value.nutrition_portion_salt,
            'traces': this.form.value.traces,
            'updated_at': new Date(),
            'updated_user': this.globals.user_name
        }).then(() => {
            if (this.update_state) {
                this.globals.GAtrackView('Dish', 'Dish - Nutrition - Update', this.globals.restaurant.email, 'Create/Update', 'Update nutrition', 'Dish', this.dish_name);
                this.navCtrl.pop();
            } else {
                this.globals.GAtrackView('Dish', 'Dish - Nutrition - Create', this.globals.restaurant.email, 'Create/Update', 'Create nutrition', 'Dish', this.dish_name);
                this.navCtrl.push(DishPreparationPage, {
                    update: this.update_state,
                    dish_uid: this.dish_uid,
                    dish_name: this.dish_name
                })
            }
        });
    }



}


// WEBPACK FOOTER //
// ./src/pages/dish/dish-create/dish-create-nutrition/dish-create-nutrition.ts